import { getUrlMvmApi } from '../utils/util';
import ApiHandler from './ApiHandler';
import { ShedSearch, ShedPost, ShedRegistrationSearch }  from '../interfaces/Shed';
import getUrlParameters from '../utils/getUrlParameters';

export const baseURL = String(getUrlMvmApi(window));

export default class ShedApi {

    static async search(params?: ShedSearch) {
        var response = await ApiHandler(baseURL).get('Shed/search', { params });
        return response.data;
    }

    static async get(shedId: number) {
        var response = await ApiHandler(baseURL).get('Shed/' + shedId);
        return response.data;
    }

    static async searchMovementType() {
        var response = await ApiHandler(baseURL).get('MovementType/search');
        return response.data;
    }

    static async getShedListByUser(userName: string) {
        var response = await ApiHandler(baseURL).get('shed/GetShedsByUser?userName='+userName);
        return response.data;
    }

    static async searchregistrationManage(params: any) {
        var response = await ApiHandler(baseURL).get('shed/search-registration-manage', { params: getUrlParameters(params) })
        return response.data;
    }

    static async create(params: ShedPost) {
        var response = await ApiHandler(baseURL).post('Shed', params);
        return response.data;
    }

    static async update(params: ShedPost) {
        var response = await ApiHandler(baseURL).put('Shed', params);
        return response.data;
    }

    static async delete(id: number) {
        var response = await ApiHandler(baseURL).delete('Shed/' + id);
        return response.data;
    }

    static async searchregistration(params: ShedRegistrationSearch) {
        var response = await ApiHandler(baseURL).get('shed/searchregistration', { params: getUrlParameters(params) });
        return response.data;
    }

    static async updateResponsibleUser(params: any) {
        await ApiHandler(baseURL).put('shed/update-responsible-user', params)
    }
}
